import clsx from "clsx";

export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={clsx("bg-slightbeige-116 animate-pulse", className)}
      {...props}
    />
  );
}
